<!-- eslint-disable vue/no-bare-strings-in-template, @intlify/vue-i18n/no-raw-text -->
<script setup>
import LaisPrimaryButton from 'dashboard/components-next/LaisPrimaryButton.vue';
import { dutySortOptions } from '../utils/reportConstants';

// Cabeçalho do plantão: contadores da fila, ordenação e recarga manual.
defineProps({
  modelValue: { type: String, default: '' },
  pendingCount: { type: Number, default: 0 },
  inProgressCount: { type: Number, default: 0 },
  loading: { type: Boolean, default: false },
});

const emit = defineEmits(['update:modelValue', 'refresh']);
</script>

<template>
  <!-- eslint-disable vue/no-bare-strings-in-template, @intlify/vue-i18n/no-raw-text -->
  <div
    class="mb-6 flex flex-col gap-3 rounded-lais border border-lais-border-soft bg-white p-4 lg:flex-row lg:items-end lg:justify-between"
  >
    <div class="grid gap-1">
      <p
        class="text-[11px] font-semibold uppercase tracking-wide text-lais-text-muted"
      >
        Fila online
      </p>
      <p class="font-redHatDisplay text-[20px] font-semibold text-lais-text">
        <span
          class="mr-2 inline-flex rounded-full bg-lais-primary px-2.5 py-0.5 text-[12px] font-semibold text-white"
        >
          {{ pendingCount }}
        </span>
        aguardando ·
        {{ inProgressCount }} em atendimento
      </p>
    </div>
    <div class="flex flex-col gap-2 sm:flex-row sm:items-center">
      <select
        :value="modelValue"
        class="h-10 rounded-lais border border-lais-border bg-white px-3 text-[14px] text-lais-text focus:border-lais-primary focus:outline-none"
        @change="emit('update:modelValue', $event.target.value)"
      >
        <option
          v-for="sort in dutySortOptions"
          :key="sort.value"
          :value="sort.value"
        >
          {{ sort.label }}
        </option>
      </select>
      <LaisPrimaryButton
        variant="ghost"
        icon="i-lucide-refresh-cw"
        :is-loading="loading"
        @click="emit('refresh')"
      >
        Atualizar
      </LaisPrimaryButton>
    </div>
  </div>
</template>
